import Link from 'next/link';
import Image from 'next/image';

const IndexPage = () => (
  <>
    <div className="flex justify-between gap-20">
      <div>
        <h2 className="mb-4 text-4xl font-normal text-black font-aeonik dark:text-white">
          Documentation
        </h2>
        <p className="mb-8 text-lg text-neutral-800 md:text-lg dark:text-neutral-300">
          Guides and quickstarts for integrating Scale products.
        </p>
        <p className="mb-4 text-base text-neutral-700 dark:text-neutral-300">
          Scale AI&apos;s mission is to accelerate the development of AI applications. To enable
          teams to make faster progress, we began with data - the foundation of all AI applications.
          Scale AI turns raw data into high-quality training data by combining machine learning
          powered pre-labeling and active tooling with varying levels and types of human review.
        </p>
        <p className="text-base text-neutral-700 dark:text-neutral-300">
          That&apos;s why we provide two tiers for our customers to use our platform:
        </p>
      </div>
      <div className="shrink-0 hidden md:block">
        <Image
          src="/static/images/illustrations/labeling-white.svg"
          width="245"
          height="270"
          alt="Docs Logo"
        />
      </div>
    </div>
    <div className="grid mt-12 mb-8 gap-9 md:grid-cols-2">
      <div className="p-8 transition-shadow duration-300 ease-in-out bg-white border border-neutral-300 dark:bg-neutral-900 dark:border-neutral-700 hover:shadow-2xl">
        <Link href="https://dashboard.scale.com/signup" className="font-normal">
          <div>
            <div className="flex items-center mb-4 text-lg text-black dark:text-white">
              <img
                className="h-6 mr-2"
                src="/static/img/website/big/icons/pricing/rapid.svg"
                alt="rapid"
              />
              Rapid
            </div>
            <p className="text-base text-neutral-700 dark:text-neutral-400">
              Our Scale Rapid model requires no long-term commitment and is a pay-as-you-go model.
              This is ideal for projects with lower volumes with production level quality and quick
              turnarounds.
            </p>
          </div>
        </Link>
      </div>
      <div className="p-8 transition-shadow duration-300 ease-in-out bg-white border border-neutral-300 dark:bg-neutral-900 dark:border-neutral-700 hover:shadow-2xl">
        <Link href="/sales" className="font-normal">
          <div className="flex flex-col h-full">
            <div className="flex items-center mb-4 text-lg text-black dark:text-white">
              <img
                className="h-6 -ml-2"
                src="/static/img/website/big/icons/section-title/enterprise-ready.svg"
                alt="enterprise"
              />
              Enterprise
            </div>
            <p className="text-base text-neutral-700 dark:text-neutral-400">
              Our Scale Enterprise model has annual commitments with volume-based rates. This is a
              deal for strategic AI initiatives with guaranteed turnaround times and quality.
            </p>
          </div>
        </Link>
      </div>
    </div>
    <p className="text-sm text-center text-neutral-700 dark:text-neutral-300">
      More information on both models can be found on our{' '}
      <Link href="/pricing" className="text-link">
        pricing page
      </Link>
      .
    </p>
    <div className="pt-12 mt-14">
      <h2 className="mb-4 text-2xl text-black dark:text-white">Need Help?</h2>
      <p className="mb-4 text-base text-neutral-700 dark:text-neutral-300">
        If you have any questions, feel free to email us at{' '}
        <a className="text-link" href="mailto:support@scale.com">
          support@scale.com
        </a>
        .
      </p>
      <p className="text-base text-neutral-700 dark:text-neutral-300">
        If you are interested in learning more about our Enterprise engagements,{' '}
        <Link href="/sales" className="text-link">
          get in touch with us
        </Link>
        .
      </p>
    </div>
  </>
);

export default IndexPage;
